import { observable, reaction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import Modal from 'react-modal';
import {UserStore} from "@intelingu/core/stores/UserStore";
import {lazyInject} from "@intelingu/core/IoC/container";

interface TrainingModalProps {
}

@observer export class TrainingModal extends Component<TrainingModalProps, any> {

    @lazyInject(UserStore) userStore: UserStore;

    render() {
        return <Modal isOpen={!this.userStore.user.intro_finished}
                      overlayClassName={'modal-overlay training-intro-overlay'}
                      ariaHideApp={false}
                      shouldCloseOnOverlayClick={true}
                      onRequestClose={() => {
                          // this.cardStore.progress.achievement = null;
                          this.userStore.closeIntro();
                      }}
                      className={'training-intro'}>

            <div className={'achievement'}>
                <div className={'bg'} style={{ background: `url(${require('assets/images/training_intro.png')})` }}>
                    <h2 style={{ textAlign: 'center' }}>WILLKOMMEN IM TRAININGS-MODUS</h2>
                    <div className={'content'}>
                        <p className={'mb-3'}>Intelingu unterscheidet sich in einigen Punkten deutlich von anderen Apps.</p>
                        <p className={'mb-3'}>Du musst einige Dinge verstehen, bevor du den maximalen Sprachlern-Erfolg aus unserem System rausholen kannst.</p>
                        <p>Daher benötigen wir für einen Moment deine Aufmerksamkeit, um dir diese Besonderheiten zu erklären. Bereit?</p>
                    </div>

                    <a href={''} className={'btn'} style={{
                        width: '100%',
                        padding: 10,
                        backgroundColor: '#fff',
                        marginTop: 30
                    }} onClick={e => {
                        e.preventDefault();
                        this.userStore.closeIntro();
                    }}>
                        START
                    </a>
                </div>
            </div>
        </Modal>
    }

}
